package cc.bluepeak.clubmanager.site.util

import cc.bluepeak.clubmanager.site.Res
import kotlinx.browser.window

enum class Platform(val string: String, val link: String, val icon: String) {
    ANDROID(Res.string.downloads_android, Res.link.android, Res.image.android),
    IOS(Res.string.downloads_ios, Res.link.ios, Res.image.apple),
    WINDOWS(Res.string.downloads_windows, Res.link.windows, Res.image.windows),
    MACOS(Res.string.downloads_mac, Res.link.macos, Res.image.apple),
    LINUX(Res.string.downloads_linux, "", ""),
    UNKNOWN("", "", "")
}

fun detectPlatform(): Platform {
    val userAgent = window.navigator.userAgent.lowercase()
    val platform = window.navigator.platform.lowercase()

    return when {
        userAgent.contains("android") -> Platform.ANDROID
        userAgent.contains("iphone") || userAgent.contains("ipad") || userAgent.contains("ipod") -> Platform.IOS
        platform.contains("win") || userAgent.contains("windows") -> Platform.WINDOWS
        platform.contains("mac") || userAgent.contains("macintosh") -> Platform.MACOS
        platform.contains("linux") -> Platform.LINUX
        else -> Platform.UNKNOWN
    }
}